import { Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import enums from "client/enums"
import { TicketStatuses } from "client/types"
import clsx from "clsx"
import { blue, green, grey, indigo, orange, red } from "theme/palettes/colors"
import { labelColors } from "./index"

interface ITicketStatusLabelProps {
  status?: TicketStatuses
  condensed?: boolean
}

const useStyles = makeStyles(theme => ({
  root: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 0,
    flexShrink: 0,
    borderRadius: theme.shape.borderRadius,
    whiteSpace: "nowrap",
    fontWeight: "bold"
  },
  normal: {
    padding: theme.spacing(0, 1.5),
    height: 40
  },
  condensed: {
    padding: theme.spacing(0, 0.5),
    height: 20,
    textTransform: "uppercase"
  },
  [TicketStatuses.Complete]: labelColors(theme, green[100], green[500]),
  [TicketStatuses.Draft]: labelColors(theme, grey[100], grey[550]),
  [TicketStatuses.Dispatched]: labelColors(theme, orange[100], orange[500]),
  [TicketStatuses.Finalized]: labelColors(theme, blue[100], blue[500]),
  [TicketStatuses.Reviewed]: labelColors(theme, blue[100], blue[500]),
  [TicketStatuses.Rejected]: labelColors(theme, red[100], red[500]),
  [TicketStatuses.Scheduled]: labelColors(theme, indigo[100], indigo[500])
  // [TicketStatuses.Required]: {
  //   backgroundColor: grey[550],
  //   color: white
  // }
}))

const TicketStatusLabel: React.FunctionComponent<ITicketStatusLabelProps> = ({
  status,
  condensed = false
}) => {
  const classes = useStyles()

  if (undefined === status) return null

  return (
    <Typography
      className={clsx(
        classes.root,
        { [classes.normal]: !condensed, [classes.condensed]: condensed },
        classes[status]
      )}
    >
      {enums.TicketStatuses.description(status)}
    </Typography>
  )
}

export default TicketStatusLabel
